/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferMainInfoResponse } from '../../models/offer-main-info-response';

export interface GetOfferMainInfo$Params {
  id: number;
}

export function getOfferMainInfo(http: HttpClient, rootUrl: string, params: GetOfferMainInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferMainInfoResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferMainInfo.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferMainInfoResponse>;
    })
  );
}

getOfferMainInfo.PATH = '/offers/{id}/main-info';
